import dayjs from 'dayjs';
import {locale} from '@/i18n';
const utc = require('dayjs/plugin/utc');
dayjs.extend(utc);
import trackBehavior from '@/utils/trackLog';

const MyPlugin = {
    install: function (vue: any) {
        vue.prototype.$dayjs = dayjs;
        vue.prototype.$trackBehavior = trackBehavior;
        vue.prototype.$isSupportIframe = window.isSupportIframe;
        vue.prototype.$isZhLang = locale.isZhLang;
        vue.prototype.$isEnglish = locale.isEnglish;
    },
};

export default MyPlugin;